export default __webpack_public_path__ + "static/media/avater5.ddec9f17.png";